import { createSlice } from '@reduxjs/toolkit';
import { sliceName } from '../../../constants';
import { vehicleRegistrationInitialState } from '../../initialStates';
var vehicleDetailSlice = createSlice({
    name: sliceName.vehicleDetailSliceName,
    initialState: vehicleRegistrationInitialState.initialRegisterVehicleState,
    reducers: {
        setVehicleDetails: function (state, action) {
            state.registrationId = action.payload.registrationId;
            state.vehicleType = action.payload.vehicleType;
            state.make = action.payload.make;
            state.model = action.payload.model;
            state.year = action.payload.year;
            state.color = action.payload.color;
            state.licensePlate = action.payload.licensePlate;
            state.state = action.payload.state;
            state.registrationType = action.payload.registrationType;
            state.parkingLocation = action.payload.parkingLocation;
            state.permitNumber = action.payload.permitNumber;
            state.registrationDate = action.payload.registrationDate;
            state.expireInDays = action.payload.expireInDays;
            state.isParkingPolicyChecked = action.payload.isParkingPolicyChecked;
            state.isCarpoolChecked = action.payload.isCarpoolChecked;
            state.carpoolStatus = action.payload.carpoolStatus;
            state.isNewLicenseChecked = action.payload.isNewLicenseChecked;
            state.userAlias = action.payload.userAlias;
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.ownerFirstName = action.payload.ownerFirstName;
            state.ownerLastName = action.payload.ownerLastName;
            state.chaufferName = action.payload.chaufferName;
            state.chaufferContactNumber = action.payload.chaufferContactNumber;
            state.chaufferDrivingLicense = action.payload.chaufferDrivingLicense;
            state.fuelType = action.payload.fuelType;
            state.contactNumber = action.payload.contactNumber;
            state.disability = action.payload.disability;
            state.parkingStickerCollected = action.payload.parkingStickerCollected;
        },
    },
});
export var setVehicleDetails = vehicleDetailSlice.actions.setVehicleDetails;
export var vehicleDetailsReducer = vehicleDetailSlice.reducer;
